module.exports = __webpack_public_path__ + "images/emoji/point_right.3b958be39c5dd70e0688.png";